import { useEffect, useState } from "react";
import "./AppCompanyHolidays.css";
import { CompanyHoliday, CompanyHolidayType } from "winslow-core";
import { apiGetCompanyHolidaysForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { set } from "lodash";
import DatePicker from "react-datepicker";
import { convertToLocalTimezone, getNthDayOfWeek, getLastWeekdayOfMonth, getNextDay} from "./companyHolidayUtils";
import { AppCompanyHolidaysPreview } from "./AppCompanyHolidaysPreview";

export type CompanyHolidayPreviewType = {
    name: string;
    thisYear: Date | null;
    nextYear: Date | null;
}

type AppPTOHolidaysProps = {
}

export const AppCompanyHolidays = ({}: AppPTOHolidaysProps) => {

    const storeUser = useSelector(selectUser);

    const [addingHoliday, setAddingHoliday] = useState<boolean>(false);
    const [companyHolidays, setCompanyHolidays] = useState<CompanyHoliday[] | undefined>(undefined);
    const [newCompanyHoliday, setNewCompanyHoliday] = useState<any | undefined>(undefined);

    useEffect(() => {

        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        // Fetch company holidays from the server
        (async () => {
            const companyHolidays = await apiGetCompanyHolidaysForWorkspace(storeUser.currentWorkspaceId || "");

            console.log("[AppCompanyHolidays] companyHolidays: ", companyHolidays);

            if (companyHolidays) {
                setCompanyHolidays(companyHolidays);
            }

            // if (companyHolidays) {
            //     const holidaysProcessed = companyHolidays.map((holiday) => {
            //         let thisYear: Date | null = null;
            //         let nextYear: Date | null = null;

            //         switch (holiday.type) {
            //             case CompanyHolidayType.DATE:
            //                 if (holiday.date) {
            //                     const useDate = convertToLocalTimezone(holiday.date);
            //                     thisYear = new Date(useDate.getFullYear(), useDate.getMonth(), useDate.getDate());
            //                     nextYear = new Date(useDate.getFullYear() + 1, useDate.getMonth(), useDate.getDate());

            //                     console.log("[AppCompanyHolidays] holiday.date: ", holiday.date);
            //                     console.log("[AppCompanyHolidays] useDate: ", useDate);
            //                     console.log("[AppCompanyHolidays] thisYear: ", thisYear);
            //                     console.log("[AppCompanyHolidays] nextYear: ", nextYear);
            //                 }
            //                 break;
            //             case CompanyHolidayType.NTH:
            //                 if (holiday.nth && holiday.dayOfWeek && holiday.month) {
            //                     thisYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, new Date().getFullYear());
            //                     nextYear = getNthDayOfWeek(holiday.nth, holiday.dayOfWeek, holiday.month, new Date().getFullYear() + 1);
            //                 }
            //                 break;
            //             case CompanyHolidayType.LAST:
            //                 if (holiday.dayOfWeek && holiday.month) {
            //                     thisYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, new Date().getFullYear());
            //                     nextYear = getLastWeekdayOfMonth(holiday.dayOfWeek, holiday.month, new Date().getFullYear() + 1);
            //                 }
            //                 break;  
            //             // case CompanyHolidayType.DAY_AFTER:
            //             //     if (holiday.date) {
            //             //         const nextDay = getNextDay(holiday.date);
            //             //         thisYear = new Date(nextDay.getFullYear(), nextDay.getMonth(), nextDay.getDate());
            //             //         nextYear = new Date(nextDay.getFullYear() + 1, nextDay.getMonth(), nextDay.getDate());
            //             //     }
            //         }

            //         return {
            //             name: holiday.name,
            //             thisYear: thisYear,
            //             nextYear: nextYear,
            //         } as CompanyHolidayPreviewType;
            //     })

            //     holidaysProcessed.sort((a, b) => {
            //         if (a.thisYear && b.thisYear) {
            //             return a.thisYear.getTime() - b.thisYear.getTime();
            //         } else if (a.thisYear && !b.thisYear) {
            //             return -1;
            //         } else if (!a.thisYear && b.thisYear) {
            //             return 1;
            //         } else {
            //             return 0;
            //         }
            //     })

            //     setCompanyHolidays(holidaysProcessed);

            // }

        })();
    }, []);

    const handleAddHoliday = () => {
        setAddingHoliday(true);
        setNewCompanyHoliday({
            name: "",
            type: CompanyHolidayType.DATE,
            date: new Date(),
            repeats: false,
            dayOfWeek: 0,
            month: 1,
            nth: 1,
        });
    }
      

    // const thisYear = new Date().getFullYear();
    // const nextYear = thisYear + 1;

    return (
        <div className="app-company-holidays">
            <div className="app-company-holidays-header">
                Company Holidays
            </div>
            <div className="app-company-holidays-content">

                <div className="app-company-holidays-add">
                    <a 
                        onClick={handleAddHoliday}
                    >
                        Add a custom holiday
                    </a>
                            
                </div>
                {addingHoliday &&
                    <div className="app-company-holidays-new">
                        <div className="app-company-holidays-new-header">
                            New Holiday
                        </div>
                        <div className="app-company-holidays-new-name">
                            <input 
                                type="text" 
                                placeholder="Holiday Name"
                                value={newCompanyHoliday?.name}
                                onChange={(e) => {
                                    setNewCompanyHoliday({
                                        ...newCompanyHoliday,
                                        name: e.target.value,
                                    })
                                }}
                            />
                        </div>
                        <div className="app-company-holidays-new-date">
                            <DatePicker
                                selected={newCompanyHoliday.date} 
                                dateFormat={"MM/dd/yyyy"}
                                onChange={(date) => {
                                    setNewCompanyHoliday({
                                        ...newCompanyHoliday,
                                        date: date as Date || new Date(),
                                    });
                                }}
                                className="date-picker-input"
                                wrapperClassName="app-date-picker-wrapper"
                            />
                        </div>
                        {newCompanyHoliday?.date &&
                            <div className="app-company-holidays-new-repeat">
                                <label>Repeats</label>
                                <input 
                                    type="checkbox" 
                                    checked={newCompanyHoliday?.repeats}
                                    onChange={(e) => {
                                        setNewCompanyHoliday({
                                            ...newCompanyHoliday,
                                            repeats: e.target.checked,
                                        })
                                    }}
                                
                                />

                            </div>
                        }

                        {newCompanyHoliday?.date && newCompanyHoliday?.repeats &&
                            <div className="app-company-holidays-new-repeat-options">
                                <input
                                    type="radio"
                                    name="holiday-type"
                                    onChange={(e) => {
                                        setNewCompanyHoliday({
                                            ...newCompanyHoliday,
                                            type: CompanyHolidayType.DATE,
                                        })
                                    }}
                                    checked={newCompanyHoliday?.type === CompanyHolidayType.DATE}
                                />
                                <label>Date</label>
                                <input
                                    type="radio"
                                    name="holiday-type"
                                    onChange={(e) => {
                                        setNewCompanyHoliday({
                                            ...newCompanyHoliday,
                                            type: CompanyHolidayType.NTH,
                                        })
                                    }}
                                    checked={newCompanyHoliday?.type === CompanyHolidayType.NTH}
                                />
                                <label>Day of Week</label>
                            </div>                    
                        }
                        
                        <div className="app-company-holidays-new-actions">
                            <a 
                                onClick={() => {
                                    setAddingHoliday(false);
                                    setNewCompanyHoliday(undefined);
                                }}
                            >
                                Cancel
                            </a>
                            <a 
                                onClick={() => {
                                    console.log("[AppCompanyHolidays] newCompanyHoliday: ", newCompanyHoliday);
                                }}
                            >
                                Save
                            </a>
                        </div>

                    </div>
                }

                <AppCompanyHolidaysPreview
                    companyHolidays={companyHolidays}
                /> 

                {/* <div className="app-company-holidays-grid">
                    <div className="app-company-holidays-grid-header-item">Holiday</div>
                    <div className="app-company-holidays-grid-header-item">{thisYear}</div>
                    <div className="app-company-holidays-grid-header-item">{nextYear}</div>
                
                    {companyHolidays && companyHolidays.map((holiday, index) => {
                        return (
                            <>
                                <div className="app-company-holidays-grid-item">
                                        {holiday.name}
                                </div>
                                <div className="app-company-holidays-grid-item">
                                  
                                        {holiday.thisYear ? holiday.thisYear.toLocaleDateString() : "N/A"}
                                </div>
                                <div className="app-company-holidays-grid-item">
                                   
                                        {holiday.nextYear ? holiday.nextYear.toLocaleDateString() : "N/A"}
                                </div>
                            </>
                        )}
                    )}
                </div> */}

            </div>
        </div>
    )
}